import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  fetchAllSiteVisits,
  unloadSiteVisitsList,
} from "../../../redux/actions";
import { token } from "../../../modules/auth";
import { Link } from "react-router-dom";
import { ButtonTertiary } from "../../Button";
import { formatDate } from "../../../modules/dates";
import Loading from "../../Loading";
import BackgroundImage from "../../General/BackgroundImage";
import * as SITE_VISIT_ROUTES from "../../../Router/site_visit_routes";

const SiteVisitSegment = ({ visit }) => {
  const image =
    (visit.visited.featured_image && visit.visited.featured_image.path) ||
    (visit.visited.images &&
      visit.visited.images[0] &&
      visit.visited.images[0].path) ||
    null;
  return (
    <Link
      to={SITE_VISIT_ROUTES.FRONTEND.SINGLE.replace(":id", visit.id)}
      className="block"
    >
      <div className="flex text-black items-start py-4 border-b border-light-grey">
        <div className="w-24 h-24 mr-4 flex-shrink-0 border border-grey-md">
          <span className="text-sm flex items-center justify-center h-full">
            {image ? (
              <BackgroundImage
                imagePath={image}
                className="bg-cover bg-center h-40 bg-light-grey"
                width={100}
                height={100}
                edits={{
                  resize: {
                    width: 100,
                    height: 100,
                    fit: "cover",
                  },
                }}
              />
            ) : (
              <img
                src={"/img/venue-placeholder.jpg"}
                className="w-full"
                alt="Venue Featured"
              />
            )}
          </span>
        </div>

        <div className="flex flex-col justify-between">
          <h4 className="font-bold text-lg mb-2">{visit?.visited?.name}</h4>
          <div className="text-base mb-2">
            <div className={"text-xs"}>
              {visit.author_visible &&
              visit.author &&
              typeof visit.author !== "undefined"
                ? `${visit.author.first_name} ${visit.author.surname} (${
                    visit?.user_type === "Agency"
                      ? "Agent"
                      : visit?.user_type || "Agent"
                  })`
                : `${
                    visit?.user_type === "Agency"
                      ? "Agent Insight"
                      : visit?.user_type === "Corporate"
                      ? "Corporate Insight"
                      : "Anonymous"
                  }`}{" "}
              - {formatDate(visit?.visit_date_from, "DD/MM/YY")}
            </div>{" "}
            <p className="mt-2 font-bold underline text-xs text-black uppercase">
              View full report
            </p>
          </div>
        </div>
      </div>
    </Link>
  );
};

function SiteVisitsDash({
  token,
  isFetchingSiteVisits,
  siteVisits,
  fetchAllSiteVisits,
  unloadSiteVisitsList,
}) {
  useEffect(() => {
    fetchAllSiteVisits(token);
    return () => {
      unloadSiteVisitsList();
    };
  }, [fetchAllSiteVisits, unloadSiteVisitsList, token]);

  return (
    <>
      {isFetchingSiteVisits ? (
        <div className="text-sm text-center">
          <Loading />
        </div>
      ) : siteVisits && siteVisits.length > 0 ? (
        <div>
          {siteVisits.slice(0, 5).map((visit, index) => (
            <SiteVisitSegment key={index} visit={visit} />
          ))}
        </div>
      ) : (
        <div className={"bg-blue-light px-2 py-8 my-4"}>
          <p className="text-sm text-center mb-0">Site visits not found</p>
        </div>
      )}

      <div className="flex justify-start">
        <ButtonTertiary
          style={{ width: "inherit" }}
          classes="text-md font-bold mr-2"
        >
          <Link to={SITE_VISIT_ROUTES.FRONTEND.VIEW} className={"text-white"}>
            View All Site Visits
          </Link>
        </ButtonTertiary>
      </div>
    </>
  );
}

const mapStateToProps = state => {
  return {
    ...state.siteVisits,
    token: token(state),
  };
};

const mapDispatchToProps = {
  fetchAllSiteVisits,
  unloadSiteVisitsList,
};

export default connect(mapStateToProps, mapDispatchToProps)(SiteVisitsDash);
